import { render, staticRenderFns } from "./Failed.vue?vue&type=template&id=0dd6bc17&scoped=true&"
import script from "./Failed.vue?vue&type=script&lang=js&"
export * from "./Failed.vue?vue&type=script&lang=js&"
import style0 from "./Failed.vue?vue&type=style&index=0&id=0dd6bc17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd6bc17",
  null
  
)

export default component.exports